import React from 'react'
import { Form } from '../../styles/FormStyle'
import styled from 'styled-components'
import { MediumButton } from '../../styles/Buttons';
import { useTranslation } from 'react-i18next';
import FormActionBtns from '../FormActionBtns';

const Option = styled.div`
  display: flex;
  justify-content: flex-start; 
  align-items: center; 


  & > label {
    margin: 0 8px 0 0; 
    font-weight: 400; 
  }

  & > input[type=radio] {
    margin: 0; 
    transform: scale(0.8); 
  }
`;

const UpcomingForm = ({ type, theme, submitTask, handleTaskChange, item, message, isEditing, handleEditCancel }) => {
    const { t } = useTranslation(); 
    return (
        <Form $theme={theme} onSubmit={submitTask}>
            <h5>{message}</h5>
            <div>
                <div>
                    <label>{`${t('upComingMeeting.formLabels.committee.name')} *`}</label>
                    <input
                        type='text'
                        name='name'
                        placeholder={t('upComingMeeting.formLabels.committee.label')}
                        value={item.name}
                        onChange={handleTaskChange}
                        required
                        spellCheck={false}
                    />
                </div>
                {type === 'national' ? (
                    <div>
                        <label>{`${t('upComingMeeting.formLabels.startDateWithTimestamp.name')} *`}</label>
                        <input
                            type='datetime-local'
                            name='start_date'
                            min='0000-01-01T00:00'
                            max='9999-12-31T23:59'
                            value={item?.start_date || ''}
                            onChange={handleTaskChange}
                            required
                        />
                    </div>
                ) : (
                    <>
                        <div>
                            <label>{t('upComingMeeting.formLabels.startDate.name')}</label>
                            <input
                                type='date'
                                name='start_date'
                                min='0000-01-01'
                                max='9999-12-31'
                                value={item?.start_date?.split('T')?.[0] || ''}
                                onChange={handleTaskChange}
                            />
                        </div>
                        <div>
                            <label>{t('upComingMeeting.formLabels.endDate.name')}</label>
                            <input
                                type='date'
                                name='end_date'
                                min='0000-01-01'
                                max='9999-12-31'
                                value={item?.end_date?.split('T')?.[0] || ''}
                                onChange={handleTaskChange}
                            />
                        </div>
                    </>
                )}
                <div>
                    <label>{`${t('upComingMeeting.formLabels.meetingType.name')} *`}</label>
                    <Option style={{ margin: '0.5rem 0 0.5rem 0' }}>
                        <label>{`${t('upComingMeeting.formLabels.meetingType.radioButtons.virtual')}:`}</label>
                        <input
                            type='radio'
                            name='presence_type'
                            value='VIRTUAL'
                            checked={item.presence_type === 'VIRTUAL'}
                            onChange={handleTaskChange}
                            required
                        />
                    </Option>
                    <Option style={{ margin: '1rem 0 0.5rem 0' }}>
                        <label>{`${t('upComingMeeting.formLabels.meetingType.radioButtons.f2f')}:`}</label>
                        <input
                            type='radio'
                            name='presence_type'
                            value='FACE_TO_FACE'
                            checked={item.presence_type === 'FACE_TO_FACE'}
                            onChange={handleTaskChange}
                            required
                        />
                    </Option>
                    <Option style={{ margin: '1rem 0 1rem 0' }}>
                        <label>{`${t('upComingMeeting.formLabels.meetingType.radioButtons.hybrid')}:`}</label>
                        <input
                            type='radio'
                            name='presence_type'
                            value='HYBRID'
                            checked={item.presence_type === 'HYBRID'}
                            onChange={handleTaskChange}
                            required
                        />
                    </Option>
                </div>
                <div >
                    <label>{t('upComingMeeting.formLabels.meetingLocation.name')}</label>
                    <input
                        type='text'
                        name='location'
                        placeholder={t('upComingMeeting.formLabels.meetingLocation.label')}
                        value={item.location}
                        onChange={handleTaskChange}
                        spellCheck={false}
                    />
                </div>
                {type === 'international' && (
                    <>
                        <div>
                            <label>{t('upComingMeeting.formLabels.registrationLink.name')}</label>
                            <input
                                type='text'
                                name='registration_url'
                                placeholder={t('upComingMeeting.formLabels.registrationLink.label')}
                                value={item.registration_url}
                                onChange={handleTaskChange}
                                spellCheck={false}
                            />
                        </div>
                        <div>
                            <label>{t('upComingMeeting.formLabels.registrationOpen')}</label>
                            <input
                                type='date'
                                name='registration_open'
                                min='0000-01-01'
                                max='9999-12-31'
                                value={item?.registration_open?.split('T')?.[0] || ''}
                                onChange={handleTaskChange}
                            />
                        </div>
                        <div>
                            <label>{t('upComingMeeting.formLabels.registrationCloses')}</label>
                            <input
                                type='date'
                                name='registration_deadline'
                                min='0000-01-01'
                                max='9999-12-31'
                                value={item?.registration_deadline?.split('T')?.[0] || ''}
                                onChange={handleTaskChange}
                            />
                        </div>
                    </>
                )}
            </div>
            {!!isEditing ? (
               <FormActionBtns 
                    theme={theme} 
                    handleEditCancel={handleEditCancel}
                />
            ) : (
                <MediumButton 
                    type='submit' 
                    $theme={theme}
                >
                    {t('common.addBtnLabel')}
                </MediumButton>
            )}
        </Form>
    )
}

export default UpcomingForm